module.exports = __webpack_public_path__ + "img/iphone.65d423d5.png";